<template>
  <v-dialog v-model="dialog" width="400">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        @click="dialog = true"
        v-on="on"
        color="primary"
        small
        tile
        outlined
        depressed
        dark
        class="mx-2"
        ><v-icon small color="primary">mdi-database-import</v-icon>
        Import Provider
      </v-btn>
    </template>
    <v-card>
      <validation-observer v-slot="{ invalid }">
        <v-card-title>Import Provider</v-card-title>

        <v-card-text class="text--center">
          <validation-provider :rules="{ required: true }" v-slot="{ errors }">
            <v-text-field
              v-model="legacyProviderId"
              label="Legacy Provider Id"
              dense
              class="ma-3"
              :error-messages="errors"
            ></v-text-field>
          </validation-provider>
          <v-overlay :value="loading">
            <v-progress-circular indeterminate></v-progress-circular>
          </v-overlay>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            :dark="!loading"
            :disabled="loading"
            @click="closeDialog"
          >
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            text
            :dark="!invalid && !loading"
            :disabled="invalid || loading"
            @click="importProvider"
          >
            Import Provider
          </v-btn>
        </v-card-actions>
      </validation-observer>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      legacyProviderId: "",
      loading: false,
    };
  },
  methods: {
    closeDialog() {
      this.legacyProviderId = "";
      this.dialog = false;
    },

    async importProvider() {
      this.loading = true;
      var importedProviderId = await this.$store.dispatch(
        "optionsModule/importSingleProvider",
        { legacyProviderId: this.legacyProviderId }
      );
      if (importedProviderId) {
        this.$router.push({
          name: "ProviderForm",
          params: { providerId: importedProviderId },
        });
      } else {
        this.$store.commit(
          "uxModule/setSnackbarMsg",
          "Error importing provider"
        );
        this.$store.commit("uxModule/setShowSnackbar", true);
      }
      this.loading = false;
      this.closeDialog();
    },
  },
};
</script>
